var map = {
	"./icon-14-check.svg": 564,
	"./icon-14-minus.svg": 565,
	"./icon-14-plus.svg": 566,
	"./icon-20-about.svg": 567,
	"./icon-20-board.svg": 568,
	"./icon-20-close.svg": 569,
	"./icon-20-create.svg": 570,
	"./icon-20-donate.svg": 571,
	"./icon-20-download.svg": 572,
	"./icon-20-edit.svg": 573,
	"./icon-20-fix.svg": 574,
	"./icon-20-logout.svg": 575,
	"./icon-20-settings.svg": 576,
	"./icon-20-share.svg": 577,
	"./icon-20-stack-active.svg": 578,
	"./icon-20-stack-enabled.svg": 579,
	"./icon-20-stack-hover.svg": 580,
	"./icon-20-timer.svg": 581,
	"./icon-20-trash.svg": 582,
	"./icon-32-add.svg": 583,
	"./icon-32-arrow-left-alt.svg": 584,
	"./icon-32-arrow-left.svg": 585,
	"./icon-32-arrow-right-alt.svg": 586,
	"./icon-32-arrow-right.svg": 587,
	"./icon-32-circle.svg": 588,
	"./icon-32-close.svg": 589,
	"./icon-32-key-down.svg": 590,
	"./icon-32-key-esc.svg": 591,
	"./icon-32-key-up.svg": 592,
	"./icon-32-more.svg": 593,
	"./icon-32-overview.svg": 594,
	"./icon-44-selection-circle-grey.svg": 595,
	"./icon-44-selection-circle.svg": 596,
	"./icon-48-chevron-left.svg": 597,
	"./icon-48-chevron-right.svg": 598,
	"./icon-48-close.svg": 599,
	"./icon-private.svg": 600,
	"./icon-public.svg": 601,
	"./inovex.svg": 602,
	"./logo-scrumlr-beta.svg": 603,
	"./logo-scrumlr-login.svg": 604,
	"./logo-scrumlr.svg": 605,
	"./phase1-01-create.svg": 606,
	"./phase1-02-communicate.svg": 607,
	"./phase1-03-combine.svg": 608,
	"./phase2-01-vote.svg": 609,
	"./phase3-01-discuss.svg": 610,
	"./phase3-02-define.svg": 611,
	"./visual-chair-scrumlr.svg": 612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 563;